import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight, Sparkles, ShieldCheck, Clock } from 'lucide-react';
import { PremiumButton, GoldDivider } from './premium/Decor';

const CTASection = ({ onOpenForm }) => {
  const { language } = useLanguage();
  const isHi = language === 'hi';
  const [time, setTime] = useState({ h: 2, m: 47, s: 33 });

  useEffect(() => {
    const t = setInterval(() => {
      setTime(p => {
        if (p.s > 0) return { ...p, s: p.s - 1 };
        if (p.m > 0) return { ...p, m: p.m - 1, s: 59 };
        if (p.h > 0) return { h: p.h - 1, m: 59, s: 59 };
        return { h: 23, m: 59, s: 59 };
      });
    }, 1000);
    return () => clearInterval(t);
  }, []);

  const fmt = (n) => String(n).padStart(2, '0');

  return (
    <section className="relative bg-brand-maroon py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-x-0 top-0 h-full pointer-events-none opacity-40"
        style={{
          backgroundImage: "url('/generated/cosmic-mandala.webp')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 20%",
          backgroundSize: "min(560px, 90%) auto",
          WebkitMaskImage: "radial-gradient(ellipse at 50% 30%, #000 30%, transparent 65%)",
          maskImage: "radial-gradient(ellipse at 50% 30%, #000 30%, transparent 65%)",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 20% 30%, rgba(212,175,55,0.18) 0%, transparent 40%), radial-gradient(circle at 80% 70%, rgba(212,175,55,0.15) 0%, transparent 40%)',
        }}
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className={`text-brand-gold-light uppercase tracking-[0.25em] text-xs sm:text-sm font-semibold mb-3 ${isHi ? 'font-hindi' : ''}`}>
          {isHi ? 'अंतिम मौका' : 'Last Chance'}
        </p>
        <h2 className={`font-playfair font-bold text-4xl md:text-5xl lg:text-6xl text-white leading-tight ${isHi ? 'font-hindi-serif' : ''}`}>
          {isHi
            ? 'अपनी कुंडली अभी प्राप्त करें'
            : 'Get Your Personal Kundli Now'}
        </h2>
        <GoldDivider className="!my-6" />
        <p className={`text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-8 ${isHi ? 'font-hindi' : 'font-outfit'}`}>
          {isHi
            ? '60+ पेज की विस्तृत वैदिक कुंडली रिपोर्ट + निःशुल्क न्यूमेरोलॉजी रिपोर्ट — सिर्फ़ ₹99 में।'
            : '60+ page detailed Vedic Kundli + free Numerology Report — for just ₹99.'}
        </p>

        {/* Countdown */}
        <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur border border-brand-gold/40 rounded-full px-5 py-2.5 mb-8">
          <Clock className="w-4 h-4 text-brand-gold-light" />
          <span className={`text-white text-sm font-semibold ${isHi ? 'font-hindi' : 'font-outfit'}`}>
            {isHi ? 'ऑफर समाप्त होगा' : 'Offer ends in'}
          </span>
          <span className="font-mono font-bold text-brand-gold-light tracking-wider">
            {fmt(time.h)}:{fmt(time.m)}:{fmt(time.s)}
          </span>
        </div>

        {/* Price */}
        <div className="flex items-baseline justify-center gap-3 mb-8">
          <span className="text-white/50 line-through font-outfit text-2xl">₹999</span>
          <span className="font-playfair font-black text-7xl md:text-8xl text-brand-gold-light">₹99</span>
        </div>

        <PremiumButton
          variant="gold"
          size="lg"
          onClick={onOpenForm}
          className="group !text-brand-maroon !font-bold"
        >
          <Sparkles className="w-5 h-5" />
          <span className={isHi ? 'font-hindi' : 'font-outfit'}>
            {isHi ? 'अभी ऑर्डर करें' : 'Order Now'}
          </span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </PremiumButton>

        <div className="mt-6 flex items-center justify-center gap-2 text-white/70 text-sm">
          <ShieldCheck className="w-4 h-4 text-brand-gold-light" />
          <span className={isHi ? 'font-hindi' : 'font-outfit'}>
            {isHi ? '100% सुरक्षित Razorpay भुगतान' : '100% Secure Razorpay Payment'}
          </span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
